document.addEventListener("DOMContentLoaded", () => {
  //  ScrollButtons Start
  const scrollButtons = document.querySelectorAll(".scroll-btn-new");

  scrollButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();

      const targetId = button.getAttribute("href");
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        const offset = 50;
        const elementPosition = targetElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    });
  });
  //  ScrollButtons End

});

///
window.initGallery = function (section) {
  if (!section) return;

  const mainEl   = section.querySelector(".gallery-slider");
  const thumbsEl = section.querySelector(".thumb-slider");
  if (!mainEl || !thumbsEl) return;

  if (mainEl.swiper || thumbsEl.swiper) return;

  const thumbs = new Swiper(thumbsEl, {
    slidesPerView: 4,
    spaceBetween: 15,
    freeMode: true,
    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
    resizeObserver: true,
    navigation: {
      nextEl: thumbsEl.querySelector(".swiper-button-next"),
      prevEl: thumbsEl.querySelector(".swiper-button-prev"),
    },
    breakpoints: {
      200: { slidesPerView: 4 },
      600: { slidesPerView: 4 },
    },
  });


  

  const gallery =  new Swiper(mainEl, {
    slidesPerView: 1,
    observer: true,
    observeParents: true,
    resizeObserver: true,
    thumbs: { swiper: thumbs },
    breakpoints: {
      200: { slidesPerView: 1 },
      600: { effect: "fade", slidesPerView: 1 },
    },
      on: {
      init(swiper) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            thumbs.update();

            swiper.update();
            swiper.updateSize();
            swiper.updateSlides();
          });
        });
      },
    },
  });

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      thumbs.update();

      gallery.update();
      gallery.updateSize();
      gallery.updateSlides();
    });
  });

};
///
function initProductGallery() {
  const productSection = document.querySelector(".--main-product-section");
  if (!productSection || typeof Swiper === "undefined") return;

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      window.initGallery(productSection);
    });
  });
}

if (document.readyState === "complete") {
  initProductGallery();
} else {
  // window.addEventListener("load", initProductGallery, { once: true });
  document.addEventListener("DOMContentLoaded", initProductGallery, { once: true });
}

// Ios Fallback
window.addEventListener("pageshow", () => {
  const section = document.querySelector(".--main-product-section");
  if (!section) return;

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      const thumbsEl = section.querySelector(".thumb-slider");
      const galleryEl = section.querySelector(".gallery-slider");

      if (!thumbsEl || !galleryEl) return;

      const thumbs = thumbsEl.swiper;
      const gallery = galleryEl.swiper;

      if (!thumbs || !gallery) {
        window.initGallery?.(section);
        return;
      }

      thumbs.update();

      gallery.update();
      gallery.updateSize();
      gallery.updateSlides();
    });
  });
});
///

/////////
  // Add to cart Functionality
 //<a data-id="{{ product.selected_or_first_available_variant.id }}" onclick="window.onClickAtc(event,this);">

  window.onClickAtc = async function (e,button) {
  e.preventDefault();
  

  const originalText = button.textContent.trim();
  button.textContent = 'Adding...';


  let productInfo = button.closest('.product-info');
  let selectedVariant = productInfo.querySelector('.--single-variant.--active-variant');


    if (!selectedVariant) {
    console.error('No active variant found');
    return;
  }

  let id = Number(selectedVariant.dataset.id.trim());

  
  const formData = {
   'items': [{
    'id': id,
    'quantity': 1
   }]
  };

  
  try {
   const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
   });
  
   if (response.ok) {
    window.location.href = '/cart';
    button.textContent = originalText;
   } else {
    button.textContent = originalText;
    console.error('Error add to cart');
   }
  } catch (error) {
    button.textContent = originalText;
   console.error('Network error:', error);
  }
 }
//////////



// Variant Management

window.variantClick = function (e, button) {
  e.preventDefault();

  if (button.classList.contains("--active-variant")) return;

  const variantId = button.dataset.id.trim();
  const section = button.closest(".--main-product-section");

  if (!section) return;


    // Switch variant button
    section.querySelectorAll(".--single-variant").forEach((variant) => {
      variant.classList.remove("--active-variant");
    });

    button.classList.add("--active-variant");


    // Switch matching description
    section.querySelectorAll(".--single-variant-description").forEach((description) => {
        const isActive = description.dataset.id.trim() === variantId;
        description.classList.toggle("--active", isActive);
    });

    // Switch What's in the Box 
    section.querySelectorAll(".accordion__wrapper.--whats-in-the-box").forEach((item) => {
        const isActive = item.dataset.id.trim() === variantId;
        item.classList.toggle("--active-variant", isActive);
    });

    // Switch Technical Specifications
    section.querySelectorAll(".accordion__wrapper.--technical-specifications").forEach((item) => {
        const isActive = item.dataset.id.trim() === variantId;
        item.classList.toggle("--active-variant", isActive);
    });

  



    console.log(`Selected variant: ${variantId}`);
    // Update price
    window.variantPrice();
    // Update price
    window.updateMedia(button);
};



///



window.variantPrice = function (button = null) { 
  const activeVariant = button || document.querySelector('.--single-variant.--active-variant'); 
  if (!activeVariant) return; 

  const section = activeVariant.closest('.--main-product-section'); 
  if (!section) return; 

  const priceWrapper = section.querySelector('.--price-wrapper'); 
  const pricePerDay = section.querySelector('.--price-per-day'); 
  if (!priceWrapper) return; 

  const currencySymbol = activeVariant.dataset.currencySymbol || ''; 
  const regularPrice = Number(activeVariant.dataset.regularPrice || 0); 
  const comparePrice = Number(activeVariant.dataset.comparePrice || 0); 
  const pricePerDayValue = activeVariant.dataset.pricePerDay || ''; 

  if (comparePrice > regularPrice) {
    priceWrapper.innerHTML = `
      <div class="--price-regular">${currencySymbol}${regularPrice.toFixed(2)}</div>
      <div class="--price-compare">${currencySymbol}${comparePrice.toFixed(2)}</div>
    `; 
  } else {
    priceWrapper.innerHTML = `
      <div class="--price-regular">${currencySymbol}${regularPrice.toFixed(2)}</div>
    `; 
  }

  if (pricePerDay) {
    pricePerDay.textContent = pricePerDayValue;
  }
};

//INIT IMAGE
const sectionImages = document.querySelectorAll(".choose-kit__image_redesign img");
if(sectionImages.length > 0) {
  sectionImages[0].classList.remove('hidden')
} 

//UPDATE IMAGE FUNCTION
window.updateMedia = function (activeVariant) {
  if (!activeVariant) return;

 const dataBlockId = activeVariant.getAttribute('data-blockid');
 const sectionImages = document.querySelectorAll(".choose-kit__image_redesign img");
if(sectionImages.length > 0) {
  sectionImages.forEach(image => {
    if(image.getAttribute('data-blockid') == dataBlockId ){
      image.classList.remove('hidden')
    } else {
      image.classList.add('hidden')
    }
  })
} 

//update text
const titleContainer = document.querySelector('.product-title-selector');
const title = titleContainer.querySelector('strong');
const titleInList = document.querySelector('.inside-the-box-list-item-text--product-title');
if(title && titleInList) {
  title.textContent = activeVariant.getAttribute('data-producttitle')
  titleInList.textContent = activeVariant.getAttribute('data-producttitle');
}
};
